import { render, staticRenderFns } from "./class-card.vue?vue&type=template&id=78d42e8a&scoped=true"
import script from "./class-card.vue?vue&type=script&lang=js"
export * from "./class-card.vue?vue&type=script&lang=js"
import style0 from "./class-card.vue?vue&type=style&index=0&id=78d42e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d42e8a",
  null
  
)

export default component.exports